import { init as getInitialState, setCurrentLocale, addStoredMessages } from '../../utils/i18n';
import { Action, Result } from '../index';
import localStorage from '../../utils/local-storage';

// Types
import { IntlState } from './types/intl';
import Locale from '@/types/locale';
import MessageSet from '@/types/message-set';

// Initial State
const INITIAL_STATE: IntlState = getInitialState();

// Actions
const SET_LOCALE: Action = {
  type: 'connect/intl/set-locale',
};

const SET_MESSAGES: Action = {
  type: 'connect/intl/add-messages',
};

// Reducer
export default function reducer(state: IntlState = INITIAL_STATE, action: Action): IntlState {
  switch (action.type) {
    case SET_LOCALE.type: {
      return {
        ...state,
        locale: action.locale,
        messages: action.messages,
      };
    }
    case SET_MESSAGES.type: {
      return {
        ...state,
        messages: action.messages,
      };
    }
    default:
      return state;
  }
}

// Action Creators
export const setLocale =
  (newLocale: Locale): Result<void> =>
  dispatch => {
    const { locale, messages } = setCurrentLocale(newLocale);
    localStorage.setLocale(locale);
    dispatch({ ...SET_LOCALE, locale, messages });
  };

export const addMessages =
  (values: MessageSet): Result<void> =>
  dispatch => {
    const messages = addStoredMessages(values);
    dispatch({ ...SET_MESSAGES, messages });
  };

export const setLocaleTemporarily =
  (newLocale: Locale): Result<void> =>
  dispatch => {
    const { locale, messages } = setCurrentLocale(newLocale);
    dispatch({ ...SET_LOCALE, locale, messages });
  };
